export default __webpack_public_path__ + "static/media/complete-req-grap.0de5f9fc.svg";